angular.module('unica_survey.survey_routes', [
	'ui.router'
])

.config(function($stateProvider) {

	$stateProvider


		// SURVEY
		.state('app.survey', {
			url: '/survey',
			abstract: true,
			views: {
				'mainContent': {
					templateUrl: './modules/survey/templates/survey.html',
					controller: 'SurveyBasicController'
				}
			},
			params: {
				need_auth: true
			}
		})

			// SURVEY LIST AND DELETE
			.state('app.survey.list', {
				url: '/list/:event_id',
				views: {
					'surveyContent': {
						templateUrl: './modules/survey/templates/list.html',
						controller: 'SurveyListController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Survey',
					parent: function($scope) {
						return 'app.event.detail({year: ' + $scope.year + ',id:' + $scope.event_id + ' })';
					}
				}
			})

			// SURVEY CREATE
			.state('app.survey.create', {
				url: '/create/:event_id',
				views: {
					'surveyContent': {
						templateUrl: './modules/survey/templates/create.html',
						controller: 'SurveyCreateController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Aggiungi Survey',
					parent: 'app.survey.list'
				}
			})


			// SURVEY EDIT
			.state('app.survey.edit', {
				url: '/edit/:event_id/:id',
				views: {
					'surveyContent': {
						templateUrl: './modules/survey/templates/edit.html',
						controller: 'SurveyEditController'
					}
				},
				params: {
					need_auth: true
				},
				ncyBreadcrumb: {
					label: 'Modifica Survey',
					parent: 'app.survey.list'
				}
			});


});

